import { DeveloperRoute } from "../../types/route-helpers";

export default function DiaryPage(): React.JSX.Element {
  return (
    <DeveloperRoute>
      <div>Nothing to see here yet</div>
    </DeveloperRoute>
  );
}
